function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconMenuFavoriteOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.544 22.307c-2.203 2.019-4.443 3.565-5.71 4.391a44.779 44.779 0 01-5.613-4.509c-2.867-2.715-6.264-6.834-6.215-10.977.037-2.95 2.548-5.335 5.6-5.3 1.957.024 3.717 1.015 4.714 2.656l1.686 2.786 1.747-2.75c1.034-1.618 2.819-2.574 4.776-2.562 3.052.035 5.514 2.455 5.477 5.406-.05 4.143-3.545 8.18-6.462 10.848m.997-18.166c-2.744-.024-5.157 1.37-6.498 3.47-1.292-2.125-3.68-3.576-6.425-3.6-4.16-.047-7.57 3.175-7.618 7.2C1.889 20.55 15.797 29 15.797 29s14.092-8.168 14.19-17.517c.05-4.013-3.298-7.306-7.458-7.353",
    fill: props.color
  }));
}

export default SvgIconMenuFavoriteOutline;